//@flow
import Collection from '../../Utils/Collection/parsedCollection';
import CreditCardModel from './creditCardModel';
import type { CreditCardObject } from './creditCardModel';
import _ from 'underscore';

export default class CreditCardsCollection extends Collection<CreditCardObject, CreditCardModel> {
  __modelClass() {
    return CreditCardModel;
  }

  findById(id:?(string|number)):?CreditCardModel {
    return _.find(this.models, card => String(card.getId()) === String(id));
  }

  usesAddressId(addressId:string|number):boolean {
    return _.any(this.models, card => card.getAddressId() === parseInt(addressId));
  }

  hasStripeCards():boolean {
    return _.any(this.models, (card) => {
      const type = card.getProcessorType();
      return type === 'stripe' || type === 'cryozonic_stripe';
    });
  }

  getAnyStripeCard():?CreditCardModel {
    return _.find(this.models, (card) => {
      const type = card.getProcessorType();
      return type === 'stripe' || type === 'cryozonic_stripe';
    });

  }

  hasAmazon():boolean {
    return _.any(this.models, card => card.getProcessorType() === 'amazon');
  }

  getAmazonCreditCard():?CreditCardModel {
    return _.find(this.models, card => card.getProcessorType() === 'amazon');
  }

  getValidCards(methods:?string[]):CreditCardModel[] {
    const validCards = [];

    this.models.forEach((card) => {
      const isValid = methods ?  methods.includes(card.getProcessorType()) : true;
      // We don't want to consider amazon payment as a card for now
      if (!isValid || card.getProcessorType() == 'amazon') return;

      const duplicateIndx = _.findIndex(validCards, validCard => {
        return validCard.getLast4() === card.getLast4() &&
          validCard.getExpMonth() === card.getExpMonth() &&
          validCard.getExpYear() === card.getExpYear();
      });

      // We want stripe cards to have priority
      if (duplicateIndx < 0) {
        validCards.push(card);
      } else if (card.getProcessorType() === 'cryozonic_stripe') {
        validCards[duplicateIndx] = card;
      }
    });

    return validCards;
  }
}
